import * as ngCore from '@angular/core'
import { ComponentStore } from '@ngrx/component-store'

import * as state from '../../../../../../../state'

import { State } from './state'

/**
 * Maintains the org chart
 */
@ngCore.Injectable()
export class Store extends ComponentStore<State> {
  /** @see {@link state.summit.orgChart.Feature} */
  public readonly orgChartFeature = ngCore.inject(state.summit.orgChart.Feature)

  /** @see {@link State.orgChartId} */
  public readonly orgChartIdSg = this.selectSignal(_state => _state.orgChartId)

  constructor() {
    super(State.INITIAL)
  }
}
